const reviewsSummaryMapper = props => {
  const { reviews, reviewsIframeId } = props;
  return {
    ...reviews,
    reviewsIframeId,
  };
};

export default reviewsSummaryMapper;
